const RadioButton2 = ({ id, text, name, onChange, checked, value }) => {
    return (
      <label htmlFor={id} className="radiobutton-label2">
        <input
          className="radiobutton-input"
          type="radio"
          name={name}
          id={id}
          value={value}
          onChange={onChange}
          checked={checked}
        />
        <span className="custom-radiobutton2" />
        {text}
      </label>
    );
  };
  
  export default RadioButton2;